import { render, staticRenderFns } from "./AnswerTypeRadioButton.vue?vue&type=template&id=d935f936&scoped=true"
import script from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRadioButton.vue?vue&type=style&index=0&id=d935f936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d935f936",
  null
  
)

export default component.exports